import React, { useState, useEffect, memo } from 'react';
import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';
import '@material/ripple/dist/mdc.ripple.css';
import '@rmwc/icon/icon.css';
import { useTranslate } from 'react-polyglot';
import CoaTextField from '../textfield';
import ActionButtons from '../actionsDialog/ActionButtons';

const ChangeProjectName = memo(function ChangeProjectName(params) {
    const t = useTranslate();

    const {setOpen, actionHandler} = params;
    const [value, setValue] = useState(params.data);

    return (
        <div className='coa-dialog-form coa-dialog-with-action-buttons'>
            <CoaTextField
                data={value}
                onChange={setValue}
                label={t('common.labels.nameCampaign')}
            />
        <ActionButtons
            cancelText={t('actions.cancel')}
            acceptText={t('actions.accept')}
            acceptDisabled={value.trim() === '' || value.trim() === params.data}
            onClickCancel={(e) => {
                e.preventDefault();
                setOpen(false);
            }}
            onClickAccept={(e) => {
                e.preventDefault();
                actionHandler(value);
            }}
        ></ActionButtons>
    </div>
    )
});

export default ChangeProjectName;